<template>
<p class="wrap"><span>{{ i18n.lbl_wait_30() }}</span>&nbsp;&nbsp;<span class="wait-text">{{ timerDisplay }}</span></p>
</template>

<script>
import { i18n } from '@js/i18n'
export default {
  name: 'Timer',
  data () {
    return {
      i18n
    }
  },
  computed: {
    timerDisplay () {
      return `${this.formatTime(this.hours)}:${this.formatTime(this.minutes)}:${this.formatTime(this.seconds)}`
    },
    minutes () {
      return this.$store.state.timer.minutes
    },
    hours () {
      return this.$store.state.timer.hours
    },
    isError () {
      return this.$store.state.timer.isError
    },
    seconds () {
      return this.$store.state.timer.seconds
    },
    action () {
      return this.$store.state.timer.action
    }
  },
  methods: {
    formatTime (time) {
      return time < 10 ? `0${time}` : time
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  max-width: 600px;
  font-size: 18px;
}
.wait-text {
  font-weight: bold;
  display: inline-block;
}
</style>


// WEBPACK FOOTER //
// src/vue/app/timer/Timer.vue